import { Modal } from "@mantine/core";
import React from "react";
import { ReactComponent as MailIcon } from "@assets/icons/mail.svg";
import { ReactComponent as PennyIcon } from "@assets/icons/penny_icon.svg";
import SectionHeaderTitle from "@components/Section/SectionHeaderTitle";
import PennyInput from "@components/Inputs/PennyInput";
import CardInformation from "@components/Cards/CardInformation";
import { Link } from "react-router-dom";

type ModalSaveQuoteProps = {
  open: boolean;
  onClose(): void;
};

const ModalSaveQuote: React.FC<ModalSaveQuoteProps> = ({ open, onClose }) => {
  return (
    <Modal
      overlayProps={{
        opacity: 0.25,
      }}
      size={628}
      centered
      withCloseButton={false}
      opened={open}
      onClose={onClose}
      styles={{
        body: {
          padding: "0px",
        },
        content: {
          borderRadius: "16px",
          background: "#FFF",
          boxShadow:
            "0px 4px 6px -2px rgba(0, 0, 0, 0.06), 0px 12px 16px -4px rgba(0, 0, 0, 0.10)",
        },
      }}
    >
      <div className="pt-6 px-6 flex items-center">
        <div className="rounded-full bg-pn_gray-lush flex items-center justify-center w-[54px] h-[54px]">
          <MailIcon />
        </div>
        <div className="w-[54px] h-[54px] -z-10 -translate-x-6 bg-[#F4E34E] flex items-center justify-center rounded-full">
          <PennyIcon width={27} height={30} />
        </div>
      </div>

      <SectionHeaderTitle
        label="Save quote"
        description="Keep the quote Penny calculated based on your information by adding your email below."
      />

      <div className="py-4 px-6 flex flex-col gap-y-4">
        <PennyInput label="Email Address" placeholder="Enter email address" />

        <CardInformation
          variant="safe"
          description={
            <div className="text-callout-regular">
              Your information is always safe with Penny.{" "}
              <Link
                to="#"
                className="text-pn-callout-link text-pn_cyan-500 !font-semibold"
              >
                Learn more about how we do it.
              </Link>
            </div>
          }
        />
      </div>

      <div className="pb-6 px-6 pt-2 flex items-center space-x-2 justify-between">
        <span className="text-pn-callout-regular text-pn_gray-600">
          Alway ensure to check your email spam folder
        </span>

        <div className="flex items-center gap-x-4">
          <button className="btn-secondary-sm-40">Save</button>
        </div>
      </div>
    </Modal>
  );
};
export default ModalSaveQuote;
